import { c as _c } from "react/compiler-runtime";
import { InfoCircleSolid } from '@byway/icons';
import clsx from 'clsx';
import type { ItineraryCardInfoBannerProps } from './ItineraryCard.types';
import styles from './ItineraryCardInfoBanner.module.css';
export function ItineraryCardInfoBanner(t0) {
  const $ = _c(10);
  const {
    children,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "plain" : t1;
  const t2 = variant === "filled" && styles.filled;
  let t3;
  if ($[0] !== t2) {
    t3 = clsx(styles.banner, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = variant === "filled" ? "large" : "small";
  let t5;
  if ($[2] !== t4) {
    t5 = <span className={styles.icon} aria-hidden={true}><InfoCircleSolid size={t4} decorative={true} /></span>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== children) {
    t6 = <p className={styles.text}>{children}</p>;
    $[4] = children;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t5 || $[8] !== t6) {
    t7 = <div className={t3} role="note">{t5}{t6}</div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}